import React from "react";
import ChangePassword from "../components/ChangePassword";

const ChangePasswordScreen = (props) => {
  return <ChangePassword {...props} />;
};
export default ChangePasswordScreen;
